import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { MarkAsPaidComponent } from '../mark-as-paid/mark-as-paid.component';

@Component({
  selector: 'app-paid-details',
  templateUrl: './paid-details.component.html',
  styleUrls: ['./paid-details.component.css']
})
export class PaidDetailsComponent implements OnInit {

  invoiceUuid: any;
  paidDetails: any;
  showPaymentDiv = false;
  note_details: any;
  type: any;
  action: any;


  constructor(private matDialog: MatDialogRef<any> , @Inject(MAT_DIALOG_DATA) public data: any,
   private accountService: AccountService,private dialog: MatDialog) { }

  ngOnInit() {
    this.invoiceUuid = this.data;
    this.accountService.getPaidInvoiceDetails(this.invoiceUuid)
    .subscribe( response => {
      this.paidDetails = response;
      console.log(this.paidDetails)
    });
  }
  togglePaymentDetails() {
    this.showPaymentDiv = !this.showPaymentDiv;
  }
  getPaymentNote(paymentNote) {
    const paymentDetais = JSON.parse(paymentNote);
    // console.log('Payment details for date ....' + JSON.stringify(paymentDetais));
    return paymentDetais.note;

  }

  getCollectedDate(paymentNote) {
    const paymentDetais = JSON.parse(paymentNote);
    // console.log('payment details for notes....' + JSON.stringify(paymentDetais));
    return paymentDetais.date;
  }
   addNote(details,type,action){
     this.note_details = details;
     this.type =type;
     this.action  = action
    const markasPaidDialog = this.dialog.open(MarkAsPaidComponent, {
      width: '900px',
      data: { 'details': this.note_details, 'type' : this.type, 'action' : this.action}
    });

    markasPaidDialog.afterClosed().subscribe(result => {


    });
  }
}
